import React from "react";

import { ErrorPage, ErrorPageInner, ErrorBox, StyledIcon, Title } from "./Styles";

const PageError = () => (
  <ErrorPage>
    <ErrorPageInner>
      <ErrorBox>
        <StyledIcon type="bug" />
        <Title>There’s been a glitch…</Title>
        <p>Some informative message here...</p>
      </ErrorBox>
    </ErrorPageInner>
  </ErrorPage>
);

export default PageError;
